"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var content_1 = require("../../../ProductsApp/ducks/content");
var children_module_scss_1 = __importDefault(require("../../../ProductsApp/components/RootMenu/children.module.scss"));
var styles_1 = __importDefault(require("./styles"));
var ProductsList = function (_a) {
    var activeItem = _a.activeItem, onClick = _a.onClick;
    var items = (0, react_redux_1.useSelector)(content_1.itemsOfContentSelector);
    var titles = (0, react_redux_1.useSelector)(content_1.titleOfContentSelector);
    return (react_1.default.createElement(styles_1.default.Container, null,
        react_1.default.createElement(styles_1.default.List, null, items.map(function (_a) {
            var singular = _a.singular, title = _a.title, preview = _a.preview, minPrice = _a.minPrice;
            return (react_1.default.createElement("div", { key: singular, onClick: function () { return onClick(singular); } },
                react_1.default.createElement(styles_1.default.Item, { active: singular === activeItem },
                    react_1.default.createElement("div", { className: children_module_scss_1.default.preview },
                        react_1.default.createElement("img", { loading: "lazy", src: preview, alt: title })),
                    react_1.default.createElement("div", { className: children_module_scss_1.default.title }, title.length > 25 ? "".concat(title.slice(0, 25), "...") : title),
                    react_1.default.createElement("div", { className: children_module_scss_1.default.price },
                        "\u043E\u0442 ",
                        minPrice))));
        })),
        react_1.default.createElement(styles_1.default.Action, null,
            react_1.default.createElement(styles_1.default.Button, { onClick: function () {
                    var popular = document.getElementById('popular');
                    var other = document.getElementById('other');
                    popular
                        ? popular.scrollIntoView({ behavior: 'smooth' })
                        : other === null || other === void 0 ? void 0 : other.scrollIntoView({ behavior: 'smooth' });
                } },
                "\u0415\u0449\u0435 ",
                titles.base),
            react_1.default.createElement(styles_1.default.Hint, { onClick: function () {
                    var _a;
                    return (_a = document
                        .getElementById('cta-form')) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
                } }, "\u041D\u0435 \u043D\u0430\u0448\u043B\u0438, \u0447\u0442\u043E \u0438\u0441\u043A\u0430\u043B\u0438?"))));
};
exports.default = ProductsList;
